import React from 'react';
import { DataGridExportButton, DataGridPremium } from '@clatter/ui';

export const columns = [
  {
    headerName: 'Site',
    field: 'site',
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Pages',
    field: 'pages',
    valueGetter: (value, row) => row.pages.length,
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Pageviews',
    field: 'views',
    sortable: true,
    flex: 1,
  },
  {
    headerName: 'Clicks',
    field: 'clicks',
    sortable: true,
    flex: 1,
  },
];

const PageviewsBySite = ({ isLoading = false, rows = [], exportFileName }) => {
  return (
    <DataGridPremium
      showVerticalSidebar
      loading={isLoading}
      dataGridProps={{
        getRowClassName: (params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd',
      }}
      renderCustomToolbar={() => <DataGridExportButton exportFileName={exportFileName} />}
      name="report/msm-pageviews-page-site"
      columns={columns}
      defaultSortField={{ field: 'site', sort: 'desc' }}
      rows={rows}
      getRowId={(row) => row.uuid}
      disableColumnFilter
    />
  );
};

export default PageviewsBySite;
